import { WHATSAPP_LINK } from "@/lib/api";
import { motion } from "framer-motion";

export default function WhatsappFab() {
  return (
    <motion.a
      data-testid="whatsapp-fab"
      href={WHATSAPP_LINK("Hello Dr Sidhu, I'd like to enquire about a consultation.")}
      target="_blank"
      rel="noreferrer"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.5, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="fixed bottom-6 right-6 z-40 group"
    >
      <span className="inline-flex items-center gap-3 pl-4 pr-5 py-3 rounded-full bg-ink text-bone shadow-[0_10px_40px_-10px_rgba(0,0,0,0.4)] border border-black/10 hover:bg-forest transition-colors">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden><path d="M17.6 6.32A7.9 7.9 0 0 0 12.05 4a7.94 7.94 0 0 0-6.9 11.87L4 20l4.24-1.11a7.94 7.94 0 0 0 3.8.97h.01A7.94 7.94 0 0 0 20 12.94a7.9 7.9 0 0 0-2.4-6.62Zm-5.55 12.2a6.55 6.55 0 0 1-3.34-.92l-.24-.14-2.52.66.67-2.46-.15-.25a6.6 6.6 0 1 1 12.24-3.47 6.55 6.55 0 0 1-6.66 6.58Zm3.6-4.94c-.2-.1-1.16-.57-1.34-.63-.18-.07-.31-.1-.44.1s-.5.63-.62.76c-.11.14-.23.15-.42.05-.2-.1-.83-.31-1.58-.98a5.87 5.87 0 0 1-1.1-1.35c-.11-.2-.01-.3.09-.4.1-.09.2-.23.3-.34.1-.11.13-.2.2-.33.06-.14.03-.25-.02-.35-.05-.1-.44-1.06-.6-1.46-.16-.38-.32-.33-.44-.34l-.38-.01a.73.73 0 0 0-.52.24 2.2 2.2 0 0 0-.69 1.63c0 .96.7 1.9.8 2.03.1.14 1.38 2.1 3.34 2.94.46.2.83.32 1.12.4.47.15.9.13 1.24.08.38-.06 1.16-.47 1.32-.93.16-.46.16-.85.11-.93-.05-.09-.18-.14-.38-.24Z"/></svg>
        <span className="text-[13px] tracking-wide">WhatsApp Dr Sidhu</span>
      </span>
    </motion.a>
  );
}
